import api from 'api'

export type GetUserOutstandingBalanceOptions = {
  userId: number
}

export type UserOutstandingBalance = {
  // Stripe
  earningsWithStripe: number
  pendingStripePayouts: number
  completedStripePayouts: number
  // Marqeta
  earningsWithMarqeta: number
  pendingMarqetaPayouts: number
  completedMarqetaPayouts: number
  // Highnote
  earningsWithHighnote?: number
  pendingHighnotePayouts?: number
  completedHighnotePayouts?: number
  // Everee
  earningsWithEveree: number
  completedEvereePayouts: number
  pendingEvereePayouts: number

  // BBSI
  completedBbsiPayouts: number

  // None has semantic value here
  stripeBalanceCached: number | undefined
  stripeBalanceLive: number | undefined

  marqetaBalanceLive: number | undefined
}

export const getUserOutstandingBalance = async ({
  userId,
}: GetUserOutstandingBalanceOptions): Promise<UserOutstandingBalance> => {
  const response = await api.get(
    `/admin/user_payments/${userId}/outstanding_balance`
  )
  return response.data
}
